export function GetYoutubeUrlFromPageName() {
  let youtubeUrlList = [];
  const copyLinkDocument = {
    name: "youtube_List.Copy_link_document",
    url: "https://www.youtube.com/embed/YUn6WWqWTlU?rel=0;controls=0",
    isShow: false,
  };
  const printPDF = {
    name: "youtube_List.Print_PDF",
    url: "https://www.youtube.com/embed/jGy3pQdiIrY?rel=0;controls=0",
    isShow: false,
  };
  const editDocument = {
    name: "youtube_List.Edit_document",
    url: "https://www.youtube.com/embed/PzVifPoYxBU?rel=0;controls=0",
    isShow: false,
  };
  const refreshDocument = {
    name: "youtube_List.Refresh_document",
    url: "https://www.youtube.com/embed/OH3tU14eKIc?rel=0;controls=0",
    isShow: false,
  };

  youtubeUrlList = [copyLinkDocument, printPDF, editDocument, refreshDocument];

  return youtubeUrlList;
}
